export default __webpack_public_path__ + "static/media/woman_at_desk.f0e52e93.jpg";